import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Store} from '@ngxs/store';
import {Observable} from 'rxjs';
import {PlayerState} from '../../store/player.state';


@Component({
  selector: 'gg-top-panel',
  templateUrl: './top-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopPanelComponent implements OnInit {
  public isLive$ = this.store.select(state => state.player.isLive);
  public apiData$ = this.store.select(state => state.player.apiData);
  public viewers$ = new Observable(); // this.counterStore.select(state => state.viewers);

  constructor(private store: Store) {

  }

  ngOnInit() {
  }

}
